<!-- .dropcart -->
<div [class]="{
    dropcart: true,
    'dropcart--style--dropdown': type === 'dropdown',
    'dropcart--style--offcanvas': type === 'offcanvas',
    'dropcart--open': state.isOpen$|async
}">
    <div *ngIf="type === 'offcanvas'" class="dropcart__backdrop" (click)="close()"></div>
    <div class="dropcart__body">
        <div *ngIf="type === 'offcanvas'" class="dropcart__header">
            <div class="dropcart__title">Carrello</div>
            <button class="dropcart__close" type="button" (click)="close()">
                <app-icon name="cross-12" size="12"></app-icon>
            </button>
        </div>

        <div class="dropcart__empty" *ngIf="!(cart.items$|async).length">
            Il tuo carrello è vuoto!
        </div>
        <ng-container *ngIf="(cart.items$|async).length">
            <div *ngIf="store.price == 'b2b'" class="text-center mt-1" style="font-size: 12px;">IVA esclusa</div>
            <div class="dropcart__products-list">
                <div *ngFor="let item of cart.items$|async" class="dropcart__product">
                    <div class="dropcart__product-image product-image">
                        <a
                            *ngIf="item.product.cdn_url"
                            class="product-image__body"
                            [routerLink]="root.product(item.product)"
                            (click)="closeMenu.emit()">
                            <img class="product-image__img" [src]="item.product.cdn_url" alt="">
                        </a>
                    </div>
                    <div class="dropcart__product-info">
                        <div class="dropcart__product-name">
                            <a [routerLink]="root.product(item.product)" (click)="closeMenu.emit()">{{ item.product.descart }}</a>
                        </div>

                        <div style="color: gray;" *ngIf="item.product.conf_active as conf">
                            {{conf.codice_confezione}} ({{conf.pezzi_confezione}} pz.) × {{item.quantity / conf.pezzi_confezione}}
                        </div>

                        <ul *ngIf="item.options" class="dropcart__product-options">
                            <ng-container *ngFor="let i of [1, 2, 3, 4]">
                                <li *ngIf="item.options[i]">{{ item.options[i].list.descrizione }}: {{ item.options[i].option.codice }}</li>
                            </ng-container>
                        </ul>

                        <ul *ngIf="item.box_levels && getBoxContentDescription(item.box_levels) as desc" class="dropcart__product-options tooltip_wider">
                            <li *ngFor="let box_item of desc.slice(0, desc.length == 3 ? 3 : 2)">{{box_item}}</li>

                            <ng-template #compTemplate>
                                <li *ngFor="let box_item of desc.slice(2)" style="white-space: nowrap;">{{box_item}}</li>
                            </ng-template>

                            <div *ngIf="desc.length != 3 && desc.length > 2">
                                <li>... e altri {{desc.length - 2}} <i class="fa fa-info-circle" [tooltip]="compTemplate" 
                                    style="cursor: pointer; color: #00adff"></i>
                                </li>
                            </div>
                        </ul>

                        <ul *ngIf="item.attributi" class="dropcart__product-options tooltip_wider">
                            <li *ngFor="let attribute of item.attributi.slice(0, item.attributi.length == 3 ? 3 : 2)">
                                + {{attribute.descrizione}}
                            </li>

                            <ng-template #attrTemplate>
                                <li *ngFor="let attribute of item.attributi.slice(2)">
                                    + {{attribute.descrizione}}
                                </li>
                            </ng-template>

                            <div *ngIf="item.attributi.length != 3 && item.attributi.length > 2">
                                <li>... e altri {{item.attributi.length - 2}} <i class="fa fa-info-circle" [tooltip]="attrTemplate"
                                    style="cursor: pointer; color: #00adff"></i>
                                </li>
                            </div>
                        </ul>

                        <div class="dropcart__product-meta">
                            <span class="dropcart__product-quantity">{{ item.quantity }}</span> ×
                            <span class="dropcart__product-price">{{ cart.itemPriceWithAttributes(item, true) | currencyFormat }}</span>
                        </div>
                    </div>

                    <button type="button" class="dropcart__product-remove btn btn-light btn-sm btn-svg-icon" (click)="remove(item)" [ngClass]="{'btn-loading': removedItems.includes(item)}">
                        <app-icon name="cross-10" size="10"></app-icon>
                    </button>
                </div>
            </div>

            <div class="dropcart__totals">
                <table>
                    <tr>
                        <th>Totale articoli</th>
                        <td>{{ cart.subtotal$|async|currencyFormat }}</td>
                    </tr>
                    <tr>
                        <th>Totale</th>
                        <td>{{ cart.total$|async|currencyFormat }}</td>
                    </tr>
                </table>
            </div>

            <div class="dropcart__buttons flex-column" style="gap: 5px">
                <a class="btn btn-primary-darken" style="margin-right: 0;" [routerLink]="root.cart()" (click)="closeMenu.emit()">Vai al carrello</a>
                <a *ngIf="account.user$ | async" class="btn btn-secondary" (click)="salvaCarrello()">Salva carrello</a>
                <!-- <a class="btn btn-primary" [routerLink]="root.checkout()" (click)="closeMenu.emit()">Checkout</a> -->
            </div>
        </ng-container>
    </div>
</div>
<!-- .dropcart / end -->
